const formatPrice = (number) => (number ? number.toString().replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1,') : 0);

export default formatPrice;
